module.exports = __webpack_public_path__ + "static/media/2.e55580f8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/2.mp3
// module id = 81
// module chunks = 0